export default __webpack_public_path__ + "static/media/border-down.238b7f3a.svg";